class Panel {

	constructor() {
		this.config = {
			axisLeft: null,
			axisRight: null,
			axisDual: null,
			primaryAxis: null,
			series: [],
			height: null, // remaining height is equally apportioned for panels with height: null
			isActive: true
		};
	}

	axisLeft(axis, isPrimaryAxis = true) {
		this.config.axisLeft = axis;

		if (isPrimaryAxis) {
			this.config.primaryAxis = 'left';
		}

		return this;
	}

	axisRight(axis, isPrimaryAxis = false) {
		this.config.axisRight = axis;

		if (isPrimaryAxis) {
			this.config.primaryAxis = 'right';
		}

		return this;
	}

	axisDual(axis) {
		this.config.axisDual = axis;
		return this;
	}

	series(series) {
		this.config.series = series;
		return this;
	}

	height(height) {
		this.config.height = height;
		return this;
	}

	isActive(isActive) {
		this.config.isActive = isActive;
		return this;
	}

}

export function panel() {
	return new Panel();
}



// WEBPACK FOOTER //
// ./utils/panelgraph/components/panel.js